<template lang="pug">
#admin_container.container-small
  h1#container_title 설치매장 추가
  .container_wr
    #s41.sub
      .in
        .total_board_list_wrap
          table.guest_table
            colgroup
              col(width='120px')
              col(width='160px')
              col(width='120px')
              col
            tbody
              tr
                th
                  label 지역
                td(colspan='2')
                  select#ca_name.s_tit(v-model='args.firstCat' @change='getSecCategory(args.firstCat)')
                    option(value='') 도/시 선택
                    option(v-for="row in area" :key="row.num" :value='row.num') {{row.name}}
                  select#ca_name.s_tit.secondCat(v-model='args.secondCat' v-if="args.nation == 'kr'")
                    option(value='') 구/군
                    option(v-for="area in secondCat" :key="area.idx" :value='area.idx') {{area.name}}
                th.nation_th
                  label 언어
                td(colspan='2')
                  select.s_tit(v-model='args.nation' @change='getArea()')
                    option(value='kr') 한국어
                    option(value='en') 영어
              tr
                th(rowspan=2) 주소
                td(colspan=2)
                  input#wr_subject.frm_input.full_input.required.post_code(v-model='args.postCode' readonly ref="postCode")
                td(colspan=2)
                  button.area_btn(@click='getAddr()') 주소검색
                td
              tr
                td(colspan='3')
                  input#wr_subject.frm_input.full_input.required.post_code(v-show="args.nation == 'kr'" v-model='args.addrKR' ref="addrKR" readonly)
                  input#wr_subject.frm_input.full_input.required.post_code(v-show="args.nation == 'en'" v-model='args.addrEN' ref="addrEN" readonly)
                td(colspan='2')
                  input#addr_area.frm_input.full_input.required(v-model='args.detailAddr' placeholder='상세주소')
              tr
                th 지점명
                td(colspan='3')
                  input#wr_subject.frm_input.full_input.required(v-model='args.shopName')
                td(colspan='2')
              tr
                th 전화번호
                td(colspan='3')
                  input#wr_subject.frm_input.full_input.required(v-model='args.mobile')
                
                td(colspan='2')
              tr
                th 매장메모
                td(colspan='5')
                  input#wr_subject.frm_input.full_input.required(v-model='args.memo' maxlength='100')
              tr
                th.add_file(valgin='middle' rowspan=2)
                  span.fir_span 파일첨부
                  span.sec_span
                    img.add_img(:src='require("../../../assets/images/btn_file_add.gif")' alt='add' @click='addFile()')
                    img.minus_img(:src='require("../../../assets/images/btn_file_minus.gif")' alt='minus' @click='delFile()')
                  span  
                td(colspan='5')
                  table#variableFiles(cellpadding='0' cellspacing='0')
                    tbody
                      tr
                        td
                          input(type='file' multiple @change='onInputImage(1)' ref='fileUploadFir')
              tr
                td(colspan='5' v-if="both_file==2")
                  table#variableFiles(cellpadding='0' cellspacing='0')
                    tbody
                      tr
                        td
                          input(type='file' multiple @change='onInputImage(2)' ref='fileUploadSec')
          .board_btn
            button#btn_submit(@click='addStore()') 확인
            button#btn_list(@click='$_goTo({name: "store-admin"})') 목록

</template>
<script src="//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script>
<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      both_file: 1,
      secondCat: [],
      area: [],
      args: {
        nation: 'kr',
        firstCat: '',
        secondCat: '',
        memo: '',
        mobile: '',
        postCode: '',
        shopName: '',
        addrEN: '',
        addrKR: '',
        detailAddr: '',
        firstFile: '',
        secondFile: '',
      },
    };
  },
  computed: {
    ...mapGetters(['checkAdminPage']),
  },
  methods: {
    onInputImage(num) {
      if (num == 1) {
        this.args.firstFile = this.$refs.fileUploadFir.files[0];
      }
      if (num == 2) {
        this.args.secondFile = this.$refs.fileUploadSec.files[0];
      }
    },
    addFile() {
      if (this.both_file == 1) {
        this.both_file++;
      } else {
        alert('이 게시판은 2개 까지만 파일 업로드가 가능합니다.');
      }
    },
    delFile() {
      if (this.both_file == 2) {
        this.both_file--;
      }
    },
    addStore() {
      if (
        this.args.firstCat == '' ||
        (this.args.secondCat == '' && this.args.nation == 'kr')
      ) {
        alert('지역을 선택해주세요.');
      } else if (this.args.addr == '') {
        alert('주소를 입력해주세요.');
      } else if (this.args.shopName == '') {
        alert('지점명을 입력해주세요.');
      } else {
        if (this.args.memo.length > 100) {
          alert('매장메모의 글자 수를 초과하였습니다.');
          return;
        } else if (
          (this.args.shopName.length > 46 && this.args.nation == 'en') ||
          (this.args.shopName.length > 31 && this.args.nation == 'kr')
        ) {
          alert('매장이름의 글자 수를 초과하였습니다.');
          return;
        }
        const formData = new FormData();
        if (this.args.nation == 'kr') {
          formData.append('SHOP_SECOND_ADDR', this.args.secondCat);
          formData.append('SHOP_ADDR', this.args.addrKR);
        } else if (this.args.nation == 'en') {
          formData.append('SHOP_ADDR', this.args.addrEN);
          formData.append('SHOP_ADDR_KR', this.args.addrKR);
        }

        if (this.args.firstFile !== '') {
          const firBlob = new Blob([this.args.firstFile], {
            type: this.args.firstFile.type,
          });
          formData.append('FILE_PATH_FIR', firBlob, this.args.firstFile.name);
        }
        if (this.args.secondFile !== '') {
          const secBlob = new Blob([this.args.secondFile], {
            type: this.args.secondFile.type,
          });
          formData.append('FILE_PATH_SEC', secBlob, this.args.secondFile.name);
        }

        formData.append('SHOP_FIRST_ADDR', this.args.firstCat);
        formData.append('SHOP_MEMO', this.args.memo);
        formData.append('SHOP_MOBILE', this.args.mobile);
        formData.append('POST_CODE', this.args.postCode);
        formData.append('SHOP_NAME', this.args.shopName);
        formData.append('SHOP_DETAIL_ADDR', this.args.detailAddr);
        formData.append('nation', this.args.nation);

        this.$_upLoad('post', 'admin/store', formData).then(res => {
          if (res) {
            alert('작성이 완료되었습니다.');
            this.$_goTo({ name: 'store-admin' });
          } else {
            alert('작성에 실패하였습니다.');
            return;
          }
        });
      }
    },
    getArea() {
      this.args.firstCat = '';
      this.$_admin_get('admin/store/area', {
        nation: this.args.nation,
      }).then(res => {
        this.area = res.data.res;
      });
    },
    getSecCategory(val) {
      if (this.$route.query.nation == 'en') {
        return;
      }
      this.args.secondCat = '';
      this.$_admin_get('admin/store/area/second', { area_num: val })
        .then(res => {
          this.secondCat = res.data.res;
        })
        .catch(() => {});
    },
    getAddr() {
      const $_this = this;
      new daum.Postcode({
        oncomplete: function (data) {
          // 팝업에서 검색결과 항목을 클릭했을때 실행 코드
          var addr = '';
          var extraAddr = '';
          var addrEN = '';
          var extraAddrEN = '';

          if (data.userSelectedType === 'R') {
            // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
            addrEN = data.roadAddressEnglish;
          } else {
            // 사용자가 지번 주소를 선택했을 경우 ('J')
            addr = data.jibunAddress;
            addrEN = data.jibunAddressEnglish;
          }

          // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
          if (data.userSelectedType === 'R') {
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
              extraAddr += data.bname;
              extraAddrEN += data.bnameEnglish;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if (data.buildingName !== '' && data.apartment === 'Y') {
              extraAddr +=
                extraAddr !== '' ? ', ' + data.buildingName : data.buildingName;
              extraAddrEN +=
                extraAddrEN !== ''
                  ? ', ' + data.buildingName
                  : data.buildingName;
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            // if (extraAddr !== '') {
            //   extraAddr = ' (' + extraAddr + ')';
            // }
          }

          // 우편번호와 주소 정보를 해당 필드에 넣는다.
          $_this.args.postCode = data.zonecode;
          $_this.args.addrEN = addrEN + ' ' + extraAddrEN;
          $_this.args.addrKR = addr + ' ' + extraAddr;
          // 커서를 상세주소 필드로 이동한다.
          document.getElementById('addr_area').focus();
        },
      }).open();
    },
  },
  mounted() {
    this.args.nation = this.checkAdminPage.store[1];
    this.getArea();
  },
};
</script>
<style>
@import '../../../assets/css/store.css';
@import '../../../assets/css/contact-fir.css';
@import '../../../assets/css/contact-sec.css';
#s41.sub {
  padding: 0;
  /* padding-top: 30px; */
}
.nation_th {
  width: 120px;
}
.secondCat {
  margin-left: 5px;
}
.post_code {
  background-color: #f7f7f7;
}
.area_btn {
  padding: 11px 15px;
  border-radius: 6px;
  font-weight: bolder;
  color: #333;
  background-color: #fff;
  border: 1px solid #ddd;
  font-size: 14px;
}
.area_btn:hover {
  background-color: #ddd;
}
.add_file {
  vertical-align: middle;
}
.fir_span {
  display: inline-block;
  vertical-align: middle;
}
.sec_span {
  display: inline-block;
}
.add_img {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  margin-right: 1px;
}
.minus_img {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
}
.sub_right {
  padding: 120px 0;
}
@media (max-width: 1024px) {
  .sub_right {
    padding: 100px 0;
  }
}
@media (max-width: 768px) {
  .sub_right {
    padding: 80px 0;
  }
}
.board_btn {
  text-align: center;
  padding: 20px;
}
.board_btn button#btn_submit {
  padding: 10px 25px;
  background: #333;
  color: #fff;
  border: 1px solid #ddd;
  line-height: 100%;
  cursor: pointer;
}
.board_btn button#btn_list {
  padding: 10px 25px;
  background: #fff;
  color: #333;
  border: 1px solid #ddd;
  line-height: 100%;
  cursor: pointer;
}
</style>
